import {
    type ApiResult,
    type BaseParams,
    type GetGroupCollectionsResponse,
    type GroupCollectionsFilterQuery,
    type GroupParam,
    links,
    Request,
} from '@app/client';
import { apiFactory } from '@app/client/apiFactory/api';

/**
 * GET the collections of a group.
 */

/**
 * GET the collections of a group. Using the Request.getRequest.
 */
const getGroupCollections = (
    params: BaseParams<GroupCollectionsFilterQuery> & Required<GroupParam>,
): Promise<ApiResult<GetGroupCollectionsResponse>> =>
    Request.getRequest<GetGroupCollectionsResponse>({
        ...params,
        target: links.pods.single(params.groupId).collections(),
    });

/**
 * GET the collections of groups. Using the Request.getRequest.
 */
const getGroupsCollections = (
    params: BaseParams<GroupCollectionsFilterQuery>,
): Promise<ApiResult<GetGroupCollectionsResponse>> =>
    Request.getRequest<GetGroupCollectionsResponse>({
        ...params,
        target: links.pods.collections,
    });
/**
 * GET the collections of a group using the APIClient.
 * If {groupId} is not provided, a reject promise is thrown before the call.
 */
export const callGetGroupCollections = (
    params: BaseParams<GroupCollectionsFilterQuery> & GroupParam,
): Promise<GetGroupCollectionsResponse> =>
    typeof params.groupId === 'undefined'
        ? Promise.reject(new Error('Invalid groupId'))
        : apiFactory()
              .call(getGroupCollections, {
                  ...params,
                  groupId: params.groupId,
                  settings: {
                      ...params.settings,
                  },
              })
              .then((result) => {
                  if (result.ok) {
                      return result.value;
                  }
                  const errorMessage =
                      result?.error?.detail && typeof result.error.detail === 'string'
                          ? result.error.detail
                          : `Error getting collections for ${params.groupId}`;
                  throw new Error(errorMessage);
              });

export const callGetGroupsCollections = (
    params: BaseParams<GroupCollectionsFilterQuery> & GroupParam,
): Promise<GetGroupCollectionsResponse> =>
    apiFactory()
        .call(getGroupsCollections, {
            ...params,
            settings: {
                ...params.settings,
            },
        })
        .then((result) => {
            if (result.ok) {
                return result.value;
            }
            const errorMessage = result?.error?.detail;
            throw new Error(errorMessage);
        });
